import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EErrorTypes {
  Set = 'NEW_ANSWER/ERROR/SET',
}

export type TSetError = ITypedReduxAction<EErrorTypes.Set, string>;

export const setError: (text: string) => TSetError = actionGenerator<EErrorTypes.Set, string>(EErrorTypes.Set);
